const FIELD_EDIT_EVENTS = [ "input", "change" ]

function fieldIsEmpty(field) {
  if (field.type === "checkbox" || field.type === "radio") return !field.checked

  return field.value.trim() === ""
}

function removeErrorForField(field) {
  const container = field.closest(".form-group, [data-error-scope]")
  if (!container) return

  container.querySelectorAll(".error").forEach(error => {
    if (error.textContent.trim() === "") return

    error.remove()
  })
}

function clearFieldError(event) {
  const field = event.target
  if (!(field instanceof Element)) return
  if (!field.matches("input, textarea, select")) return
  if (fieldIsEmpty(field)) return

  field.classList.remove("is-invalid")
  removeErrorForField(field)
}

export function initFieldErrorClearing() {
  FIELD_EDIT_EVENTS.forEach(event => document.addEventListener(event, clearFieldError))
}
